import { render, staticRenderFns } from "./moneyValueConfig.vue?vue&type=template&id=1de106ed&scoped=true&"
import script from "./moneyValueConfig.vue?vue&type=script&lang=js&"
export * from "./moneyValueConfig.vue?vue&type=script&lang=js&"
import style0 from "./moneyValueConfig.vue?vue&type=style&index=0&id=1de106ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de106ed",
  null
  
)

export default component.exports